var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loadingBalls" },
    _vm._l(_vm.ballColor, function (ball, index) {
      return _c("div", {
        key: index,
        staticClass: "ball",
        class: _vm.toggleAnimation ? "" : "bounceAnimationClass",
        style: { background: ball, animationDelay: 0.2 * index + "s" },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }